import MobileSubmissionDetailsHeader from './MobileSubmissionDetailsHeader';
import MobileSubmissionDetailsHeaderContainer from './MobileSubmissionDetailsHeader.container';

export default MobileSubmissionDetailsHeaderContainer(
  MobileSubmissionDetailsHeader
);
